import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DealerProfile } from '@app/domain/model/dealer-profile';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-dealer-panel',
  templateUrl: './dealer-panel.component.html',
  styleUrls: ['./dealer-panel.component.scss']
})
export class DealerPanelComponent implements OnInit, OnDestroy {
  private dataSubscription: Subscription;
  profile: DealerProfile;

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.dataSubscription = this.route.data.subscribe(({ profile }) => {
      this.profile = profile;
    });
  }

  ngOnDestroy() {
    this.dataSubscription.unsubscribe();
  }

}
